import { http } from '@/lib/ats-https';

interface PushApplicationToHrisParams {
  application_id?: string;
  [key: string]: unknown;
}

/**
 * HRIS employee-push service.
 *
 * Relocated here from `src/pages/hris/api.ts` so cross-feature consumers
 * (the ATS HRIS-integration component hooks) stop importing into the hris
 * page layer. The original module re-exports this for within-feature callers.
 */
const pushApplicationToHris = async (params: PushApplicationToHrisParams) => {
  const response = await http.post(
    `/ats_applications/${params?.application_id}/hris_employees`,
    params
  );
  return response;
};

export interface AtsJobDetail {
  id?: number;
  name?: string;
  job_profile?: {
    id?: number;
    name?: string;
    job_title?: string;
  } | null;
}

/**
 * Job detail, for the linked job profile.
 *
 * The application payload embeds a trimmed `ats_job` (id, name, status,
 * offices, permissions) that omits `job_profile`, so the HRIS hire form has to
 * fetch the job itself to prefill the Job Profile field.
 */
const getAtsJob = async (jobId: string | number): Promise<AtsJobDetail> => {
  const response = await http.get(`/ats_jobs/${jobId}`);
  return response?.data;
};

export const HRIS_QUERY_KEYS = {
  atsJob: (jobId: string | number) => ['hris', 'atsJob', jobId] as const,
};

export const HRIS_API_SERVICE = {
  pushApplicationToHris,
  getAtsJob,
};
